import React from 'react';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import DropdownField from '../DropdownField';
import addHttpPrefix from 'lib/utils/addHttpPrefix';

const SingleLinkFieldset = ({ urlTypes, formErrors, required }) => {
  const isLocked = false;

  const handleUrlBlur = value => addHttpPrefix(value.replace(/\s/g, ''));

  const typeProps = {
    name: 'links[0].type',
    component: DropdownField,
    inputProps: { valueField: 'id', textField: 'name', disabled: isLocked },
    error: formErrors.getIn(['links', '0', 'type']),
    data: urlTypes,
    type: 'text',
    className: 'form-control',
    placeholder: 'Select a URL Type',
    required: required
  };

  const urlProps = {
    name: 'links[0].url',
    error: formErrors.getIn(['links', '0', 'url']),
    component: 'input',
    inputProps: { disabled: isLocked },
    type: 'url',
    className: 'form-control',
    placeholder: 'http://',
    required: required,
    normalizeOnBlur: handleUrlBlur,
  };

  return (
    <div className='row'>
      <div className="col-12 col-lg-3">
        <FormField label="Type" {...typeProps}/>
      </div>
      <div className="col-lg-9">
        <FormField label="URL Address" {...urlProps} />
      </div>
    </div>
  );
};

SingleLinkFieldset.propTypes = {
  formErrors: PropTypes.object,
  urlTypes: PropTypes.array.isRequired,
  lockedType: PropTypes.string,
};

SingleLinkFieldset.defaultPros = {
  lockedType: null,
};

export default SingleLinkFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/SingleLinkFieldset.jsx